// plan-02 S02: DPR helper — caps devicePixelRatio at 2 for predictable canvas cost

const MAX_DPR = 2

export function effectiveDpr(): number {
  return Math.min(window.devicePixelRatio ?? 1, MAX_DPR)
}

export function canvasSize(canvas: HTMLCanvasElement): { w: number; h: number } {
  const dpr = effectiveDpr()
  const w = Math.floor(window.innerWidth * dpr)
  const h = Math.floor(window.innerHeight * dpr)
  canvas.width = w
  canvas.height = h
  canvas.style.width = window.innerWidth + 'px'
  canvas.style.height = window.innerHeight + 'px'
  return { w, h }
}
